module.exports = __webpack_public_path__ + "img/base_restauration_producteur_vin.2254a12f.svg";